import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  connect() {
    this.pasteInput();
  }
  
  pasteInput(e) {
    document.getElementById("login-portal").addEventListener("paste", (e) => {
      e.preventDefault();
      const pastedValue = e.clipboardData.getData('text');

      const pastedValuePadronize = pastedValue.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      const splitedValue = pastedValuePadronize.split("\n");

      if (splitedValue.length < 6) return;
      for (let i = 0; i < (splitedValue.length); i++) {
        if (!splitedValue[i]) return;
        const input = document.getElementById(`confirmation_${i}`);
        if (input) input.value = splitedValue[i];
      }
    });
  }

  requestToken(e) {
    post(e.currentTarget.dataset.url, {
      contentType: "text/vnd.turbo-stream.html",
      responseKind: "turbo-stream"
    })
  }

  singleDigitInput(e) {
    const input = e.target;

    if (input.value.length > 1 ) {
      input.value = input.value.slice(0, 1);
    }
  }
}